import { CheckCircle } from "lucide-react";

export default function EuropeStudentVisaConsultant() {
    return (
        <section className="w-full pb-16 px-4 sm:px-6 lg:px-16 bg-white">
            <div className="max-w-7xl mx-auto flex flex-col gap-8">

                {/* Main Heading */}
                <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900">
                    Why Choose Shivasya – Europe Student Visa Consultant in Ahmedabad?
                </h3>

                {/* Intro Paragraph */}
                <div className="text-justify space-y-4 text-gray-800 text-base sm:text-lg lg:text-xxl leading-relaxed">
                    <p>
                        Visa procedures differ across European countries and require detailed documentation and compliance.
                        At <strong>Shivasya Education</strong> and Immigration Services, our expert team provides:
                    </p>
                </div>

                {/* Bullet Points */}
                <ul className="space-y-3 text-gray-800 text-base sm:text-lg">
                    <li>✔ Guidance on selecting the correct visa type</li>
                    <li>✔ Assistance with financial proof documentation</li>
                    <li>✔ Help with part-time work regulations</li>
                    <li>✔ Support with local authority registration after arrival</li>
                    <li>✔ Complete document digitization and visa submission</li>
                    <li>✔ Post-study work visa guidance</li>
                </ul>

                {/* Closing Paragraph */}
                <div className="text-justify space-y-4 text-gray-800 text-base sm:text-lg lg:text-xxl leading-relaxed">
                    <p>
                        We ensure accuracy, transparency, and higher chances of visa approval through professional support and up-to-date knowledge.
                    </p>
                </div>

                {/* CTA Section */}
                <h4 className="text-xl sm:text-2xl font-bold text-gray-900">
                    Take the First Step Today
                </h4>

                <div className="text-justify space-y-4 text-gray-800 text-base sm:text-lg lg:text-xxl leading-relaxed">
                    <p>
                        Acquiring a Europe student visa may seem complex, but with the right guidance and proper planning, the process becomes smooth and achievable.
                    </p>
                    <p>
                        Book your free counseling session with Shivasya and turn your European study dreams into reality.
                    </p>
                </div>
            </div>
        </section>
    );
}